<template>
  <section class="ds-section my-3">
    <h3 v-if="title" class="ds-section__title">{{ title }}</h3>
    <div class="ds-section__body" :class="{ 'ds-section__body--plain': plain }">
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DetailSheetSection',
  props: {
    title: { type: String, default: '' },
    // `plain` drops the panel background for free-form content (prose, media)
    // that reads better without a card around it.
    plain: { type: Boolean, default: false },
  },
});
</script>

<style scoped>
/* Deliberately quiet: a section heading is a wayfinding hint, not a banner.
   Purely structural labels ("Actions", "Details") are better left off entirely —
   the panel itself does the grouping. */
.ds-section__title {
  margin: 0 0 0.375rem;
  padding-left: 0.125rem;
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 600;
}

/* Grouping the rows in a single panel replaces the old run of loose <hr> tags,
   which is what made the previous dialogs read as a list of unrelated links.
   The hairline dividers between rows are owned by the row components (they can
   see their own :first-child position inside this panel). */
.ds-section__body {
  background: var(--gray);
  border: 1px solid var(--gray-border);
  border-radius: 0.75rem;
  overflow: hidden;
}

.ds-section__body--plain {
  background: transparent;
  border: 0;
  border-radius: 0;
  overflow: visible;
}
</style>
